<template>
  <div style="padding: 2rem; background: #fff">
    <vxe-toolbar
      v-if="
        operateType === 'add' ||
        operateType === 'edit' ||
        operateType === 'renewal' ||
        operateType === 'changeInfo' ||
        operateType === 'changeSubject'
      "
    >
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('teamTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="teamTableData"
      :edit-config="editConfig"
      size="mini"
      ref="teamTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="teamTableEditRules"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        field="teamDepartmentNo"
        title="部门"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.teamDepartmentNo"
            clearable
            filterable
            @change="(val) => handleDepartmentChange(scope.row, scope)"
          >
            <el-option
              v-for="(item, index) in departmentList"
              :key="index"
              :label="item.createDepartmentName"
              :value="item.createDepartmentCode"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(
            row.teamDepartmentNo,
            departmentList,
            'createDepartmentCode',
            'createDepartmentName'
          )
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="userNo"
        title="姓名"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.userNo"
            clearable
            filterable
            @change="() => handleUser(scope.row)"
          >
            <el-option
              v-for="(item, index) in scope.row.userList || []"
              :key="index"
              :label="item.userName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.userNo, row.userList, 'userId', 'userName')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="roleNo"
        title="角色"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.roleNo"
            clearable
            filterable
            @change="() => handleRole(scope.row)"
          >
            <el-option
              v-for="(item, index) in scope.row.roleList || []"
              :key="index"
              :label="item.roleName"
              :value="item.roleNo"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.roleNo, row.roleList, 'roleNo', 'roleName')
        }}</template>
      </vxe-table-column>
      <vxe-table-column field="remark" title="备注" :edit-render="{ type: 'default' }">
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.remark" maxlength="20" />
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/property/leaseContract';
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  export default {
    name: 'teamInfo',
    props: ['detailTeamTableData'],
    mixins: [leaseContractMixin],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      operateType() {
        return this.$route.query.type;
      },
      teamTableEditRules() {
        return {
          teamDepartmentNo: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          userNo: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          roleNo: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
        };
      },
    },
    watch: {
      detailTeamTableData(newVal) {
        if (newVal) {
          this.dealData(newVal);
        }
      },
    },
    created() {
      this.getDepartmentList();
    },
    data() {
      return {
        editConfig: {},
        teamTableData: [],
        departmentList: [],
      };
    },
    mounted() {
      this.editConfig =
        this.operateType === 'add' ||
        this.operateType === 'edit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeInfo' ||
        this.operateType === 'changeSubject'
          ? { trigger: 'dblclick', mode: 'row' }
          : {};
    },
    methods: {
      insertEvent() {
        console.log('insertEvent');
        this.$refs['teamTable'].validate((valid) => {
          if (valid) {
            let record = {
              teamDepartmentNo: '',
              userNo: '',
              userName: '',
              roleNo: '',
              roleName: '',
              remark: '',
            };
            this.$refs.teamTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.teamTable.setActiveRow(row));
          }
        });
      },
      getDepartmentList() {
        const params = {
          tenantCode: this.userInfo.tenantCode,
          selectCompanyCode: this.userInfo.companyCode,
          // selectCompanyCode 指定公司下的部门
        };
        this.$axios.post(API.GET_DEPARTMENT_LIST_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data || [];
          }
        });
      },
      handleDepartmentChange(row, scope) {
        row.userNo = '';
        row.roleNo = '';
        console.log(row, '11111111');
        const params = {
          companyCode: this.userInfo.companyCode,
          departmentCode: row.teamDepartmentNo,
        };
        let userList = [];
        let roleList = [];
        this.$axios.post(API.GET_USER_LIST_API, params).then((res) => {
          console.log(res, 'res');
          if (res.data.code === 0) {
            userList = res.data.data || [];
            row.userList = userList;
            this.$refs.teamTable.reloadRow(row);
            this.$refs.teamTable.updateStatus(scope);
          }
        });
        this.$axios.get(`${API.ROLE_BY_DEPARTMENTCODE}/${row.teamDepartmentNo}`).then((roleRes) => {
          console.log(roleRes, 'roleRes');
          if (roleRes.data.code === 0) {
            roleList = roleRes.data.data || [];
            row.roleList = roleList;
            this.$refs.teamTable.reloadRow(row);
            this.$refs.teamTable.updateStatus(scope);
          }
        });
      },
      handleRole(row) {
        row.roleName = this.transferSelect(row.roleNo, row.roleList, 'roleNo', 'roleName');
      },
      handleUser(row) {
        row.userName = this.transferSelect(row.userNo, row.userList, 'userId', 'userName');
      },
      async dealData(list) {
        for (let item of list) {
          if (item.teamDepartmentNo) {
            await this.getUserList(item);
            await this.getRoleList(item);
          }
        }
        console.log(list, '-------=========');
        this.teamTableData = list;
      },
      async getUserList(item) {
        const params = {
          companyCode: this.userInfo.companyCode,
          // companyCode指 定公司下的人
          // departmentCode: item.teamDepartmentNo,
        };
        let userList = [];
        await this.$axios.post(API.GET_USER_LIST_API, params).then((res) => {
          if (res.data.code === 0) {
            userList = res.data.data || [];
          }
        });
        item.userList = userList;
      },
      async getRoleList(item) {
        let roleList = [];
        await this.$axios
          .get(`${API.ROLE_BY_DEPARTMENTCODE}/${item.teamDepartmentNo}`)
          .then((res) => {
            if (res.data.code === 0) {
              roleList = res.data.data || [];
            }
          });
        item.roleList = roleList;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
